import React from 'react';
import {withStyles} from "@material-ui/core/styles";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Podcast_Icon from "../assets/podcast_icon.svg";
import Podcast_Logo from "../assets/podcast_logo.png";

const muiTheme = createTheme({
    palette: {
        custom: {
            main: '#FFF'
        },
    },
    components: {
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: "#009BB5",
                }
            }
        }
    }
});

const useStyles = theme => ({
    panel: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        background: '#0E8064',
    },
    content: {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        flexDirection: 'column',
        padding: '40px 28px',

        [theme.breakpoints.up('md')]: {
            width: '770px',
            flexDirection: 'row',
        }
    },
    icon: {
        padding: '0 0 15px 0',

        [theme.breakpoints.up('md')]: {
            padding: '10px 15px 0 0',
        }
    },
    title: {
        fontFamily: 'Young Serif',
        fontSize: '2.6em',
        lineHeight: '1.1em',
    },
    host: {
        padding: '15px 0',
        fontFamily: 'Montserrat',
        fontSize: '1.1em',
        fontWeight: 'bold',
        lineHeight: '1.4em',
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
    },
    description: {
        fontFamily: 'Montserrat',
        fontSize: '1.4em',
        lineHeight: '1.4em',
    },
    listen: {
        padding: '20px 0',
        fontFamily: 'Montserrat',
        fontSize: '1.1em',
        fontWeight: 'bold',
        lineHeight: '1.4em',

        '& a': {
            color: 'inherit',
            textDecoration: 'underline',
        },

        '& a:hover': {
            color: 'inherit',
            textDecoration: 'none',
        },
    },
    logo: {
        [theme.breakpoints.up('md')]: {
            padding: '60px 0 0 30px',
        }
    }
});

class PodcastPanel extends React.PureComponent {
    render() {
        const { classes } = this.props;

        return (
            <ThemeProvider theme={muiTheme}>

                <div className={classes.panel}>
                    <div className={classes.content}>

                        <div className={classes.icon}><img src={Podcast_Icon} alt={"Podcast"} /></div>

                        <div className={classes.podcastContent}>
                            <div className={classes.title}>The Importance of Connecting With Nature</div>
                            <div className={classes.host}>PODCAST HOSTED BY ANHELY MILLAN</div>
                            <div className={classes.description}>Please join me on this nurturing interview and learn how to enjoy nature, appreciate and take care of our environment and how spending time outside can heal our minds and bodies.</div>
                            <div className={classes.listen}><a target="_blank" rel="noopener noreferrer" href="https://open.spotify.com/episode/2ANUhgn2BhIHH6ezkix2Vd?si=b5a51efb1aa748f4">Listen on Spotify</a></div>
                        </div>

                        <div className={classes.logo}><a target="_blank" rel="noopener noreferrer" href="https://sustainabilityforkids-au.square.site/"><img src={Podcast_Logo} alt={"Logo"} /></a></div>

                    </div>
                </div>

            </ThemeProvider>
        )
    }
}

export default withStyles(useStyles)(PodcastPanel)